<smt-modal [(isActive)]="confirmModalActive"  [allowDropDownOverflow]="true" [disableFooter]="false" [disableHeader]="true" 
    (acceptEvent)="onRemoveVarianceReasonClick()" (rejectEvent)="confirmModalActive = false" 
    acceptText="Remove" acceptCssClass="button primary" rejectText="Cancel" rejectCssClass="button cancel">
   <div role="body">
        Please confirm permanent removal of record.
   </div>
</smt-modal>
<smt-modal [(isActive)]="costCenterListModalActive"  [allowDropDownOverflow]="false" [disableFooter]="false" [disableHeader]="false"
    (acceptEvent)="costCenterListModalActive = false" (rejectEvent)="costCenterListModalActive = false"  
    acceptText="Ok" acceptCssClass="button primary"  rejectCssClass="button cancel">
    <div role="header">Cost Centers associated to {{varianceReasonName}}</div>
   <div role="body">
        <table class="condensed">
            <thead>
              <tr><th>Cost Center Name</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let costCenterName of costCenterNames"><td>{{costCenterName}}</td></tr>
            </tbody>
        </table>
   </div>
</smt-modal> 
<div class="page-header-outer">
  <div class="page-header">
      <h1>Reasons for Variance</h1>
      <div class="controls">
          <button [disabled]="!addButtonEnabled" (click)="onAddVarianceReasonClick()"><span class="icon-plus"></span> Add New</button>
      </div>
  </div>
</div>
<div class="content-inner">
  <div class="admin-main" [ngClass]="{'loading': initialLoading || mobileLoading }" >
        <div>
            <div class="admin-list" [ngClass]="{'loading': adminListLoading }"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="scrollThrottle"
                [fromRoot]="false"
                [scrollWindow]="false"
                [infiniteScrollContainer]="scrollSelector"
                (scrolled)="onScrollDown()">           
                <div class="filter-sort">
                    <div class="filter">
                        <input class="compact magic-filter" (keyup)="onSearchKey($event)" [(ngModel)]="searchText" name="SearchKey" type="text" placeholder="Search by Reason">
                    </div>
                    <div class="sort">
                        <label class="compact">Sort</label>
                        <select class="compact" (change)="onSortTypesDropDownChanged($event)" [(ngModel)]="selectedFilter" name="SortList">
                            <option *ngFor='let type of sortTypes' [value]="type" (change)="setSelectedFilter($event)">
                                {{type}}
                            </option>
                        </select> 
                        <a class="arrow compact" (click)="onChangeSortOrder()" 
                            [ngClass]="sortAscending ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold'"></a>
                    </div>
                </div>
                <ul class="adminListScroll" > 
                    <li *ngFor="let varianceReason of varianceReasons" [value]="varianceReason.id" (click)="onSelection(varianceReason)" 
                        [ngClass]="{'active': selection != undefined && selection != null && varianceReason.id == selection.id } ">
                            <ul class="flags">
                                <li class="active">
                                    <div class="added">
                                        <span class="active">
                                            <div *ngIf="varianceReason.mostRecent">
                                                <span class="icon-plus"></span> New
                                            </div>
                                        </span>                                                    
                                    </div>
                                    <div *ngIf="varianceReason.default">
                                        <span class="icon-radio-checked"></span> Default
                                    </div>
                                </li>
                            </ul>
                            <div class="title">{{ varianceReason.reason }}</div>
                            <ul class="details">
                                <li class="modified">
                                    <span class="label">Code</span>
                                    <span class="value">{{ varianceReason.code }}</span>
                                </li> 
                                <li class="modified">
                                    <span class="label">Last Modified</span>
                                    <span class="value">{{ varianceReason.modifiedDate == null ? "&nbsp;" : ( varianceReason.modifiedDate + "Z" | date: 'M/dd/yy h:mm a') }}</span>
                                </li> 
                            </ul> 
                    </li> 
                </ul>
            </div> 
            <div class="admin-action-window" [ngClass]="{ 'loading': adminActionLoading }"> 
                <div class="admin-action suppress-scroll" id="edit" [ngClass]="{ 'active': showAdminActionWindow }" *ngIf="selection">
                    <div class="header">
                        <div class="title">
                            {{ adminActionLabelText }}	
                            <button class="primary compact" [disabled]="!deleteButtonEnabled" (click)="confirmModalActive = true"><span class="icon-trash btn-Icon"></span>{{ adminActionButton1LabelText }}</button>
                            <a class="close" href="javascript:void(0)" (click)="onCancel()"><span class="icon-cross"></span></a>
                        </div>
                    </div>
                    <div>
                        <form #varianceReasonEditForm="ngForm" (ngSubmit)="onSave()">
                            <section>
                                <div class="body">
                                    <div class="form-group">
                                        <label>Reason For Variance</label>
                                        <input maxlength="500" type="text" required name="reasonReason" [readonly]="readOnly" [(ngModel)]="selectedReason">
                                    </div>
                                    <div class="form-group">
                                        <label>Code</label>
                                        <input maxlength="25" type="text" required name="reasonCode" [readonly]="readOnly" [(ngModel)]="selectedCode">
                                    </div>
                                    <div class="form-group">
                                        <label>Description</label>
                                        <input maxlength="255" type="text" name="reasonDescription" [readonly]="readOnly" [(ngModel)]="selectedDescription">
                                    </div>
                                    <div class="form-group" hidden>
                                        <label>Department Leader Prompt</label>
                                        <input maxlength="500" type="text" name="reasonDeptLeaderPrompt" [readonly]="readOnly" [(ngModel)]="selectedDeptLeaderPrompt">
                                    </div>
                                    <div class="form-group" [hidden]="readOnly">
                                        <label>Default</label>                                            
                                        <ul class="options">
                                            <li>
                                                <label>
                                                    <input type="radio" name="reasonDefaultYes" [value]="true" [(ngModel)]="selectedDefault">Yes
                                                </label>
                                            </li>
                                            <li>
                                                <label>
                                                    <input type="radio" name="reasonDefaultNo" [value]="false" [(ngModel)]="selectedDefault">No
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="form-group" [hidden]="!readOnly">
                                        <label>Default</label>                                            
                                        <input type="text" name="defaultReadOnly" *ngIf="!readOnly" [readonly]="true" [value]="selectedDefault ? 'Yes' : 'No'">
                                    </div> 
                                    <span class="inline warning" *ngIf="showCostCenterWarning" >
                                        <span class="icon-warning2">
                                        </span> This variance reason  is associated to one or more cost centers.<a class="warning" (click)="getCostCentersByVarianceReasonId(true)"> Click here for more details.</a>
                                    </span>                                   
                                </div>
                                <div class="footer">
                                    <div>
                                        <label class="errormsg">{{ getErrorMessage() }}</label> 
                                    </div>
                                    <button class="primary" type="submit" [disabled]="!varianceReasonEditForm.form.valid || !varianceReasonEditForm.dirty || !saveButtonEnabled">
                                        <span class="icon-plus"></span> Save</button>
                                    <button class="cancel" type="button" (click)="onCancel()" [disabled]="saveLoading">
                                        <span class="icon-cancel"></span> Cancel</button>
                                </div>
                            </section>
                        </form>
                    </div>      
                </div>
            </div>
        </div>
    </div>
</div>
